import { formatStockMessage } from 'components/productdetail/stylepicker/AddToCart';
import { stringTemplate } from 'helpers/stringTemplate';

export const getStockMessage = ({ lowStockMessage, onHand }: { lowStockMessage: string; onHand: number }) => {
  if (onHand > 0) {
    return formatStockMessage(stringTemplate(lowStockMessage, { onHand }));
  } else {
    return 'Out of Stock';
  }
};
